<template>
    <div class="send-email">
        <v-dialog v-model="formDialog" persistent max-width="750px">
            <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on"> Open Dialog </v-btn> -->
            <!-- <template v-slot:activator="{ on, attrs }">
            
            <v-btn color="primary" class="mb-3" v-bind="attrs" v-on="on" block depressed>
                <v-icon left>mdi-email-outline</v-icon>
                Send QR
            </v-btn>
        </template> -->
            <v-card>
                <v-toolbar color="fiord" class="text-h6" dark>Send QR</v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col sm="12" md="3" class="mt-6 py-0" @click="$refs.recipients.focus()">
                                <label for="Recipients" class="fiord--text">Recipients</label>
                            </v-col>
                            <v-col sm="12" md="9" class="mt-3 py-0" @click="$refs.recipients.focus()">
                                <div class="recipient-container d-flex">
                                    <v-chip
                                        v-for="(chipText, index) in formData.recipients"
                                        :key="index"
                                        class="ma-0 mt-2 mr-2 py-1"
                                        :class="{ error: $validate.rules.email(chipText) !== true }"
                                        close
                                        @click:close="removeRecipient(index)"
                                    >
                                        {{ chipText }}
                                    </v-chip>

                                    <div
                                        class="recipient-input ma-0 mt-2"
                                        @keydown.enter.prevent="addRecipient"
                                        @keydown.tab.prevent="addRecipient"
                                        @blur="addRecipient(false)"
                                        hide-details="auto"
                                        ref="recipients"
                                        contenteditable="true"
                                    ></div>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <v-divider :class="{ error: errors.recipients }"></v-divider>
                                <small class="error--text"> {{ errors.recipients }}</small>
                            </v-col>
                            <v-col sm="12" md="3" class="mt-4 py-0">
                                <label for="Recipient" class="fiord--text">QR to send</label>
                            </v-col>
                            <v-col sm="12" md="9" class="py-0">
                                <!-- <v-select id="qr_type" :items="[]" label="Select type..." flat solo dense></v-select> -->

                                <v-row>
                                    <v-col sm="12" md="12" class="py-0"> <v-text-field :value="data.merchantName" hide-details="auto" readonly></v-text-field> </v-col>
                                    <v-col cols="12">
                                        <v-divider></v-divider>
                                    </v-col>
                                    <v-col cols="12" class="py-0">
                                        <v-radio-group v-model="formData.partner_only" row>
                                            <v-radio :label="`${data.classification == 'BRANCH' ? 'Branch' : 'Partner'} QR only`" value="true"></v-radio>
                                            <v-radio label="Partner &amp; Branches QR" value="false"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <v-textarea v-model="formData.notes" rows="5" name="input-7-1" placeholder="Add notes here..." hide-details="auto"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-3 mx-1" outlined text @click="formDialog = false">Cancel</v-btn>
                    <v-btn color="primary" class="mb-3 mx-1" :loading="formData.loading" @click="sendEmail">Send</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog.show" scrollable max-width="540" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
            <v-card class="confirm-dialog">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon class="dialog-close" v-on="on" @click="confirmDialog.show = false">close</v-icon>
                    </template>
                    <span>Close</span>
                </v-tooltip>
                <v-card-title class="pb-3 font-weight-bold red--text"> <v-icon color="red" left>mdi-alert-circle</v-icon>Error </v-card-title>
                <v-card-text class="pb-2">
                    <p class="font-size-21 ma-0 fiord--text">{{ confirmDialog.data.modalDescription }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-container fluid>
                        <v-row align="center" justify="center">
                            <v-col cols="12" class="d-flex justify-center">
                                <v-btn class="btn-min-width font-weight-bold no-text-transform" @click="modalAction({ action: 'cancel' })" height="45" block outlined text> Okay </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    name: 'SendQrForm',
    props: {
        show: { type: Boolean, default: false, required: true },
        data: { type: Object, default: new Object() }
    },
    data() {
        return {
            dialog: false,
            formData: {
                userEmail: '',
                recipients: [],
                partner_only: 'true',
                notes: '',
                loading: false
            },
            formDialog: this.show,
            confirmDialog: { show: false, action: '', data: {} }
        };
    },
    watch: {
        show(to) {
            this.formDialog = to;
        },
        formDialog(to) {
            if (!to) {
                this.clearForm();
                this.$emit('close');
            } else {
                // // Trigger upon show of formDialog
            }
        },
        data(to) {
            let merchantData = JSON.parse(JSON.stringify(to));
            if (Object.keys(merchantData).length > 0) {
                this.formData = { ...this.formData, ...merchantData };
            }
        }
    },
    methods: {
        addRecipient(focus = true) {
            if (this.$refs.recipients.innerText != '') {
                this.formData.recipients.push(this.$refs.recipients.innerText);
                // Remove empty values on blur
                this.formData.recipients = this.formData.recipients.filter(Boolean);
                this.$refs.recipients.innerText = '';
            }

            if (focus) {
                this.$refs.recipients.focus();
            }
        },
        removeRecipient(index) {
            this.formData.recipients.splice(index, 1);
        },
        clearForm() {
            this.formData = {
                userEmail: '',
                recipients: [],
                partner_only: 'true',
                notes: ''
            };
        },
        sendEmail() {
            const invalid = this.formData.recipients.filter((recipient) => this.$validate.rules.email(recipient) !== true);

            if (invalid.length > 0) {
                this.$store.commit('form/SET_ERRORS_EMPTY');
                this.confirmAction({ action: 'error' });
            } else {
                this.formData.loading = true;
                this.$store
                    .dispatch('merchants/sendEmail', {
                        id: this.formData.id,
                        data: {
                            recipients: this.formData.recipients,
                            partner_only: this.formData.partner_only === 'true',
                            zipped: this.formData.partner_only === 'true' ? false : true,
                            notes: this.formData.notes
                        }
                    })
                    .then((response) => {
                        this.notification({ type: 'success', title: 'Send QR', message: response.message });
                        this.clearForm();
                        this.formDialog = false;
                    })
                    .catch(() => {
                        this.formData.loading = false;
                    });
            }
        },
        confirmAction({ action }) {
            switch (action) {
                case 'error':
                    this.confirmDialog.data.modalDescription = `The address in the 'Recipients' field was not recognized. Please make sure  that all addresses are properly formed.`;
                    this.confirmDialog.show = true;
                    break;
            }
        },
        modalAction({ action }) {
            switch (action) {
                case 'cancel':
                    this.confirmDialog.show = false;
                    break;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.recipient-container {
    cursor: text;
    flex-wrap: wrap;
}

.recipient-input {
    padding: 6px 0;
    word-break: break-all;
    outline: 0px solid transparent;
}

::v-deep {
    .v-input__slot:before,
    .v-input__slot:after {
        border-color: transparent !important;
        border-style: hidden !important;
    }

    .v-chip {
        height: auto !important;
    }

    .v-chip .v-chip__content {
        word-break: break-all;
        white-space: normal;
    }
}
</style>
